/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_CARD_HELPERS_EXTRACTION
 * Date:         2026-01-27
 * Modified By:  Cursor
 *
 * Description:
 * Extracted helper functions from BroadcastItemCard.tsx to reduce file size.
 *
 * File Size Check:
 * - Current: 0 (new file)
 * - Adding: ~100 lines
 * - Projected: 100 lines
 * - Decision: Proceed
 *
 * Related Files:
 * - client/src/components/broadcast/BroadcastItemCard.tsx
 */

export const getConditionBackgroundColor = (condition?: string | null): string => {
  if (!condition) return "transparent";
  const normalized = condition.toLowerCase().trim();
  
  if (normalized.includes("new retail") || normalized.includes("new bulk")) {
    return "var(--color-status-green-light)";
  }
  if (normalized.includes("used")) {
    return "var(--color-status-orange-light)";
  }
  if (normalized.includes("refurbished")) {
    return "var(--color-status-blue-light)";
  }
  if (normalized.includes("as-is") || normalized.includes("as is")) {
    return "var(--color-status-purple-light)";
  }
  
  return "transparent";
};

export const getConditionTextColor = (condition?: string | null): string => {
  if (!condition) return "inherit";
  const normalized = condition.toLowerCase().trim();
  
  if (normalized.includes("new retail") || normalized.includes("new bulk")) {
    return "var(--color-status-green)";
  }
  if (normalized.includes("used")) {
    return "var(--color-status-orange)";
  }
  if (normalized.includes("refurbished")) {
    return "var(--color-status-blue)";
  }
  if (normalized.includes("as-is") || normalized.includes("as is")) {
    return "var(--color-status-purple)";
  }
  
  return "inherit";
};

// [2026-02-13] CURRENCY_PHASE2: getCurrencySymbol and formatPrice moved to utils/priceDisplay.ts

export const formatRelativeTime = (dateString?: string): string => {
  const timestamp = dateString ? new Date(dateString).getTime() : Date.now();
  const diff = Date.now() - timestamp;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }
  if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  }
  return `${Math.max(1, minutes)} min ago`;
};
